import {
  CreateProductGroupEntity,
  ProductGroupEntity,
  UpdatePriceRangeGroup,
} from '@/pages/privatePages/productgroup/types';
import { BaseService } from './base.service';
import APIService from './axios.service';

class ProductGroupServiceClass extends BaseService<
  'productgroup',
  ProductGroupEntity,
  CreateProductGroupEntity
> {
  constructor() {
    super('product-group');
  }

  updateProductGroupPriceRange = async (
    payload: UpdatePriceRangeGroup,
  ): Promise<ProductGroupEntity> => {
    return APIService.post(this.path, payload);
  };

  getProductGroup = async (): Promise<ProductGroupEntity[]> => {
    return APIService.get(this.path);
  };
}
export const productgroupService = new ProductGroupServiceClass();
